import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "@/lib/firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { toast } from "../../components/ui/use-toast";
import { updateStats } from "./dashboardSlice";

//  Get Seller Dashboard Stats
export const getSellerDashboardStatsByUserId = createAsyncThunk(
  "auth/getSellerDashboardStatsByUserId",
  async (userId, { rejectWithValue, dispatch }) => {
    try {
      if (!userId) {
        throw new Error("User ID is required");
      }

      const sellerStatDocRef = doc(db, "sellerStats", userId);

      // Create snapshot listener
      const unsubscribe = onSnapshot(
        sellerStatDocRef,
        (snapshot) => {
          if (snapshot.exists()) {
            const statsData = {
              uid: userId,
              ...snapshot.data(),
            };
            dispatch(updateStats(statsData));
          } else {
            toast({
              title: "Error",
              description: "Seller stats not found for this user",
              variant: "destructive",
            });
          }
        },
        (error) => {
          console.error("Failed to fetch seller stats:", error);
          toast({
            title: "Error",
            description: error?.message || "Unable to fetch seller stats.",
            variant: "destructive",
          });
        }
      );

      // Return unsubscribe referenc
      return { unsubscribe };
    } catch (error) {
      console.error("Failed to fetch seller stats:", error);
      toast({
        title: "Error",
        description: error?.message || "Unable to fetch seller stats.",
        variant: "destructive",
      });
      return rejectWithValue(error?.message || "Error fetching seller stats.");
    }
  }
);

// Action to unsubscribe from real-time updates
export const unsubscribeFromSellerStats = createAsyncThunk(
  "dashboard/unsubscribeFromSellerStats",
  async (_, { getState }) => {
    const { unsubscribe } = getState().dashboard;
    if (unsubscribe) {
      unsubscribe();
    }
  }
);
